import React, { useMemo, useContext } from "react";

import Loader from "components/Loader";
import useGet from "hooks/useGet";
import { Avatar } from "antd";
import { useAuth } from "./auth";

const WorkersContext = React.createContext();

function WorkersProvider({ children }) {
  const {
    state: { user },
  } = useAuth();

  const { is_loading: is_loading_workers, data: workers } = useGet({
    path: "/workers",
    query: ["workers_list"],
    context: "list",
    search: {
      per_page: 50,
      sort: "position__asc",
    },
    options: {
      refetchOnWindowFocus: false,
    },
  });

  const { is_loading: is_loading_users, data: users } = useGet({
    path: "/users",
    query: ["users_list"],
    context: "list",
    search: {
      per_page: 50,
      sort: "position__asc",
    },
    options: {
      refetchOnWindowFocus: false,
    },
  });

  const workers_list_options = workers?.map(
    ({ id, full_name, initials, color }) => ({
      label: (
        <>
          <Avatar
            size="small"
            style={{
              backgroundColor: color,
              marginRight: 10,
            }}
          >
            {initials}
          </Avatar>
          {full_name}
        </>
      ),
      value: id,
    })
  );

  const users_list_options = users?.map(
    ({ id, full_name, initials, color }) => ({
      label: (
        <>
          <Avatar
            size="small"
            shape="square"
            style={{
              backgroundColor: color,
              marginRight: 10,
            }}
          >
            {initials}
          </Avatar>
          {full_name}
        </>
      ),
      value: id,
    })
  );

  const all_users_list_options = [
    {
      label: (
        <>
          <Avatar
            size="small"
            shape="square"
            style={{
              backgroundColor: "#000",
              marginRight: 10,
            }}
          >
            {user.initials}
          </Avatar>
          {user.full_name}
        </>
      ),
      value: user.id,
    },
    ...(users_list_options || []),
    ...(workers_list_options || []),
  ];

  const value = useMemo(() => {
    return {
      workers,
      workers_list_options,
      users_list_options,
      all_users_list_options,
    };
    // eslint-disable-next-line
  }, [
    is_loading_workers,
    is_loading_users,
    workers_list_options,
    users_list_options,
    all_users_list_options,
  ]);

  if (is_loading_workers || is_loading_users) {
    return <Loader />;
  }
  return (
    <WorkersContext.Provider value={value}>{children}</WorkersContext.Provider>
  );
}

const useWorkers = () => useContext(WorkersContext);
export { useWorkers };
export default WorkersProvider;
